class BlockSliderVertical {

	constructor(){

		let mm = gsap.matchMedia();
		resizeCallbacks.push(this);

		mm.add("(min-width: 992px)", () => {

			this.sliders = document.querySelectorAll('.block-slider-vertical');
			this.swipers = [];

			this.sliders.forEach( (slider) => {

				const swiperText = slider.querySelector('.block-slider-text');
				const swiperImage = slider.querySelector('.block-slider-image');
				const prev = slider.querySelector(".slider-button-prev");
				const next = slider.querySelector(".slider-button-next");
				const scrollbar = slider.querySelector(".slider-scroller");

				this.resize();

				let swiperTxt = new Swiper(swiperText, {
					direction: "vertical",
					speed: 600,
					navigation: {
						prevEl: prev,
						nextEl: next
					}
				});

				let swiperImg = new Swiper(swiperImage, {
					direction: "vertical",
					speed: 800,
					allowTouchMove: false
				}) ;

				this.swipers.push(swiperImg);
				this.swipers.push(swiperTxt);

				swiperTxt.controller.control = swiperImg;
				swiperTxt.scrollbar = scrollbar;

				let steps = 100/swiperTxt.slides.length;

				ScrollTrigger.create({
					trigger: slider,
					pin: true,
					start: "top top",
					end: "+="+(window.innerHeight * swiperTxt.slides.length),
					scrub: 0.3,
					onUpdate: (self) => {
						if( self.progress * 100 > steps * ( swiperTxt.activeIndex + 1 ) && self.direction > 0 ){
							swiperTxt.slideTo( swiperTxt.activeIndex+1 );
						}
						if( self.progress * 100 < steps * ( swiperTxt.activeIndex ) && self.direction < 0 ){
							swiperTxt.slideTo( swiperTxt.activeIndex-1 );
						}
						this.scrollProgress(swiperTxt, self.progress);
					}
				});

			});

			return () => { // optional
				this.swipers.forEach( (s) => {
					s.destroy();
				});
			};

		});

	}

	scrollProgress(swiper, progress){
		gsap.to(swiper.scrollbar, {
			scaleY: progress
		});
	}

	resize(){

		this.sliders.forEach( (slider) => {

			const slides = slider.querySelectorAll('.swiper-slide');
			let maxHeight = 0;
			slides.forEach( (slide) => {
				if( slide.offsetHeight > maxHeight ){
					maxHeight = slide.offsetHeight;
				}
			});

			const swiperText = slider.querySelector('.block-slider-text');
			const swiperImage = slider.querySelector('.block-slider-image');

			swiperText.style.height = maxHeight+"px";
			swiperImage.style.height = maxHeight+"px";

		});

	}

}
